export default __webpack_public_path__ + "static/media/842.f3ff5131.jpg";